import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Backdrop from "../../asserts/CRMbg.png";
import {
  GetDashboardDetails,
  handleBookingDetailsSearch,
  handleCancellationDetailsSearch,
  GetBookingDetailsByDate,
  GetBookingDetails,
  GetCancellationDetailsByDate,
  GetCancellationDetails,
  handlePassengerDetailsSearch,
  handleBlockedDetailsSearch,
  GetBlockedDetailsByDate,
  GetBlockedDetails,
} from "../../Api/Dashboard/Dashboard";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Spin,
  Tooltip,
  Popover,
  ConfigProvider,
  DatePicker,
  Select,
} from "antd";
import "../../App.css";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import {
  TbReceiptRupee,
  TbReceiptTax,
  TbRosetteDiscount,
} from "react-icons/tb";
import { FaDesktop, FaPeopleGroup } from "react-icons/fa6";
import { LiaSearchSolid } from "react-icons/lia";
import { BsExclamationCircle } from "react-icons/bs";
import BookingTable from "./BookingTable";
import { DashTable } from "./DashTable";
import CancelTable from "./CancelTable";
import PassengerTable from "./PassengerTable";
import moment from "moment";
import BlockTable from "./BlockTable";
import { IoGrid } from "react-icons/io5";
import { TiThMenu } from "react-icons/ti";
import { FaMobileAlt } from "react-icons/fa";
import axios from "axios";
import { DashTableNew } from "./DashTableNew";
import { Formik, Field, Form, ErrorMessage } from "formik";
import dayjs from "dayjs";
import all1 from "../../asserts/all1.png";
import all2 from "../../asserts/all2.png";
import { MdCancel } from "react-icons/md";
import { CgExport } from "react-icons/cg";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExportButton from "../Common/Download/Excel";
import { DashTableNewMobile } from "./DashTableNewMobile";
import { IoMdArrowDropdown } from "react-icons/io";
import { RiMenuFill } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import CancelTableMobile from "./CancelTableMobile";
import BookingTableMobile from "./BookingTableMobile";

const apiUrl = process.env.REACT_APP_API_URL;

const Dashboard = ({ setLoading }) => {
  const location = useLocation();
  const [spinning, setSpinning] = useState(false);
  const [table, setTable] = useState(location?.state?.tabIndex || "dashboard");
  console.log(table, "tableeeeeee");
  const [activePage, setActivePage] = useState(1);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isView, setIsView] = useState("All");
  const [deviceid, setDeviceId] = useState(0);
  const [activePicker, setActivePicker] = useState("Weekly");
  const [swap, setSwap] = useState("amount");
  const [dates, setDates] = useState();
  console.log("dates", dates);
  const [inputValue, setInputValue] = useState("");
  const [popoverVisible, setPopoverVisible] = useState(false);
    const [sortedData, setSortedData] = useState([]);
  const [sortOrderDate, setSortOrderDate] = useState(null);
  const [sortOrderFare, setSortOrderFare] = useState(null);

  const handleClear = () => {
    setInputValue("");
    if (table == "bookings") {
      GetBookingDetails(dispatch, setSpinning, deviceid);
    } else if (table == "cancellation") {
      GetCancellationDetails(dispatch, setSpinning, deviceid);
    }
    // else if(table=="passengers"){
    //   GetPassengerDetails(dispatch,setSpinning,deviceid);
    // }else if(table=="blocked"){
    //   GetBlockedDetails(dispatch, setSpinning,deviceid);
    // }
  };

  const handleDragStart = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
  };

  const getBookingDetails =
    useSelector((state) => state.crm.booking_details) || [];
  console.log(getBookingDetails, "booking details dashboard");

  const getCancellationDetails =
    useSelector((state) => state.crm.cancellation_details) || [];
  console.log(getCancellationDetails, "cancellation details dashboard");

  const dispatch = useDispatch();
  const getDashboardDetails =
    useSelector((state) => state.crm.dashboard_details) || [];
  console.log(getDashboardDetails, "DASHBOARD details dashboard");
  // useEffect(() => {
  //   setSpinning(true);
  //   GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 1, 1);
  // }, []);
  useEffect(() => {
    setLoading(false);
  }, []);
  const formatNumber = (value) => {
    if (value === undefined || value === null || isNaN(value)) {
      return "Invalid value";
    }

    if (value >= 1000000) {
      return (value / 1000000).toFixed(1) + "m";
    } else if (value >= 100000) {
      return (value / 1000).toFixed(1) + "k";
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1) + "k";
    } else {
      return value.toString();
    }
  };

  const infos1 = [
    {
      title: "Ticket Number",
    },
    {
      title: "PNR Number",
    },
    {
      title: "Mobile Number",
    },
    // {
    //   title: "Activated Date",
    //   description: "DD MMM (e.g. 01 Jan) - Format",
    // },
    // {
    //   title: "Expiry Date",
    //   description: "DD MMM (e.g. 01 Jan) - Format",
    // },
  ];

  const infos2 = [
    {
      title: "Mobile Number",
    },
    {
      title: "Email",
    },
  ];

  const infos3 = [
    {
      title: "Ticket Number",
    },
    {
      title: "PNR Number",
    },
    {
      title: "Mobile Number",
    },
    {
      title: "Email",
    },
  ];

  const Search = (e) => {
    if (table == "bookings") {
      if(isView==="All"){ 
      handleBookingDetailsSearch(e, dispatch,0);
      setActivePage(1);
    }else if(isView==="Desktop"){
      handleBookingDetailsSearch(e, dispatch,1);
      setActivePage(1);
    }
    else if(isView==="Mobile"){
      handleBookingDetailsSearch(e, dispatch,2);
      setActivePage(1);
    }
    } else if (table == "cancellation") {
      if(isView==="All"){
      handleCancellationDetailsSearch(e, dispatch,0);
      setActivePage(1);
    }else if(isView==="Desktop"){
      handleCancellationDetailsSearch(e, dispatch,1);
      setActivePage(1);
    }else if(isView==="Mobile"){
      handleCancellationDetailsSearch(e, dispatch,2);
      setActivePage(1);
    }
    } else if (table == "passengers") {
      handlePassengerDetailsSearch(e, dispatch);
      setActivePage(1);
    } else if (table == "blocked") {
      if(isView==="All"){
      handleBlockedDetailsSearch(e, dispatch,0);
      setActivePage(1);
      }else if(isView==="Desktop"){
      handleBlockedDetailsSearch(e, dispatch,1);
      setActivePage(1);
      }
      else if(isView==="Mobile"){
      handleBlockedDetailsSearch(e, dispatch,2);
      setActivePage(1);
      }
    }
  };

  const handleKeyDown = (e) => {
    // Allow control keys like Backspace, Delete, ArrowLeft, ArrowRight, Tab
    const isControlKey = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ].includes(e.key);

    if (isControlKey) {
      return; // If it's a control key, do nothing and allow it to execute
    }

    // Allow only alphabets (A-Z, a-z), numbers (0-9), and space
    if (!/^[A-Za-z0-9\s.@]$/.test(e.key)) {
      e.preventDefault(); // Block all other characters
    }
  };

  const handleKeyDateDown = (e) => {
    // Allow control keys like Backspace, Delete, ArrowLeft, ArrowRight, Tab
    const isControlKey = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ].includes(e.key);

    if (isControlKey) {
      return; // If it's a control key, do nothing and allow it to execute
    }

    // Allow only alphabets (A-Z, a-z), numbers (0-9), and space
    if (!/^[0-9\s]$/.test(e.key)) {
      e.preventDefault(); // Prevent the key if it's not an alphabet, number, or space
    }
  };

  const { RangePicker } = DatePicker;

  // date picker
  const changeDatePickerPlaceholder = () => {
    const inputDiv = document.querySelector(".ant-picker-input");
    if (inputDiv) {
      const inputElement = inputDiv.querySelector("input");
      if (inputElement) {
        inputElement.placeholder = "Start Date";
        inputElement.className = "text-center";
      }
    }
  };

  const changeDatePickerPlaceholder2 = () => {
    const inputDiv = document.querySelector(".ant-picker");
    if (inputDiv) {
      const children = inputDiv.querySelectorAll("div");
      if (children.length > 2) {
        const thirdChild = children[2];
        const inputElement = thirdChild.querySelector("input");
        if (inputElement) {
          inputElement.placeholder = "End Date";
          inputElement.className = "text-center";
        }
      }
    }
  };

  useEffect(() => {
    changeDatePickerPlaceholder();
    changeDatePickerPlaceholder2();
  }, [table]);

  const [dateClear, setDateClear] = useState();
  const access_id = Number(sessionStorage.getItem("accessId"));
  console.log(dateClear, "dateClear");
  useEffect(() => {
    console.log(
      table,
      isView,
      deviceid,
      dateClear,
      "Updated values after click"
    );
    console.log(dates, "Updated dates");
  }, [table, isView, deviceid, dateClear]);

  const datefilter = async (values) => {
    console.log(table, isView, deviceid, "dtihhhh");

    console.log(values, "valueeeeeeee");
    try {
      setDates(values);
      setDateClear(values);
      console.log(values, "date values");
      if (table == "bookings") {
        await GetBookingDetailsByDate(
          dispatch,
          moment(values[0].$d).format("YYYY-MM-DD"),
          moment(values[1].$d).format("YYYY-MM-DD")
        );
      } else if (table == "cancellation") {
        await GetCancellationDetailsByDate(
          dispatch,
          moment(values[0].$d).format("YYYY-MM-DD"),
          moment(values[1].$d).format("YYYY-MM-DD")
        );
      } else if (table == "blocked") {
        await GetBlockedDetailsByDate(
          dispatch,
          moment(values[0].$d).format("YYYY-MM-DD"),
          moment(values[1].$d).format("YYYY-MM-DD")
        );
      } else if (table == "dashboard") {
        if (isView === "All") {
          if (swap === "amount") {
            console.log(table, isView, deviceid, "dtihhhh");
            await GetDashboardDetails(
              dispatch,
              setSpinning,
              0,
              moment(values[0].$d).format("YYYY-MM-DD"),
              moment(values[1].$d).format("YYYY-MM-DD"),
              1,
              1
            );
          } else if (swap === "count") {
            await GetDashboardDetails(
              dispatch,
              setSpinning,
              0,
              moment(values[0].$d).format("YYYY-MM-DD"),
              moment(values[1].$d).format("YYYY-MM-DD"),
              1,
              2
            );
          }
        } else if (isView === "Desktop") {
          if (swap === "amount") {
            console.log(table, isView, deviceid, "dtihhhh");
            await GetDashboardDetails(
              dispatch,
              setSpinning,
              1,
              moment(values[0].$d).format("YYYY-MM-DD"),
              moment(values[1].$d).format("YYYY-MM-DD"),
              1,
              1
            );
          } else if (swap === "count") {
            await GetDashboardDetails(
              dispatch,
              setSpinning,
              1,
              moment(values[0].$d).format("YYYY-MM-DD"),
              moment(values[1].$d).format("YYYY-MM-DD"),
              1,
              2
            );
          }
        } else if (isView === "Mobile") {
          if (swap === "amount") {
            console.log(table, isView, deviceid, "dtihhhh");
            await GetDashboardDetails(
              dispatch,
              setSpinning,
              2,
              moment(values[0].$d).format("YYYY-MM-DD"),
              moment(values[1].$d).format("YYYY-MM-DD"),
              1,
              1
            );
          } else if (swap === "count") {
            await GetDashboardDetails(
              dispatch,
              setSpinning,
              2,
              moment(values[0].$d).format("YYYY-MM-DD"),
              moment(values[1].$d).format("YYYY-MM-DD"),
              1,
              2
            );
          }
        }
      }
      setActivePage(1);
    } catch (err) {
      console.log(err, "error");
      if (table == "bookings") {
        GetBookingDetails(dispatch, setSpinning, 0);
      } else if (table == "cancellation") {
        GetCancellationDetails(dispatch, setSpinning, 0);
      } else if (table == "blocked") {
        GetBlockedDetails(dispatch, setSpinning, 0);
      } else if (table == "dashboard") {
        setActivePicker("Weekly");
        if (isView === "All") {
          if (swap === "amount") {
            GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 1, 1);
          } else if (swap === "count") {
            GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 1, 2);
          }
        } else if (isView === "Desktop") {
          if (swap === "amount") {
            GetDashboardDetails(dispatch, setSpinning, 1, "null", "null", 1, 1);
          } else if (swap === "count") {
            GetDashboardDetails(dispatch, setSpinning, 1, "null", "null", 1, 2);
          }
        } else if (isView === "Mobile") {
          if (swap === "amount") {
            GetDashboardDetails(dispatch, setSpinning, 2, "null", "null", 1, 1);
          } else if (swap === "count") {
            GetDashboardDetails(dispatch, setSpinning, 2, "null", "null", 1, 2);
          }
        }
      }
    }
  };

  useEffect(() => {
    // setTable(location?.state?.tabIndex);
    if (showDashboard) {
      setTable(location?.state?.tabIndex);
    } else if (showBooking) {
      setTable("bookings");
    } else if (showCancel) {
      setTable("cancellation");
    }
  }, [location.state]);
  useEffect(() => {
    if (table === "dashboard") {
      if (showDashboard) {
        setTable(
          location?.state?.tabIndex ? location?.state?.tabIndex : "dashboard"
        );
      } else if (showBooking) {
        setTable("bookings");
      } else if (showCancel) {
        setTable("cancellation");
      }
    }
  }, [table]);

  useEffect(() => {
    if (deviceid) {
      console.log("deviceId updated:", deviceid);
    }
  }, [deviceid]);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      console.log(entries);
    });

    observer.observe(document.body);

    return () => observer.disconnect(); // Cleanup on unmount
  }, [dateClear]);

  const storedModulePermissions = sessionStorage.getItem("module_permission");
  const currenttypeid = sessionStorage.getItem("type_id");
  const modulePermissions = storedModulePermissions
    ? JSON.parse(storedModulePermissions)
    : [];

  const dashboardModule = [1];
  const showDashboard = dashboardModule.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const bookingModule = [2];
  const showBooking = bookingModule.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const cancelModule = [3];
  const showCancel = cancelModule.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );

  const options = [
    {
      value: 1,
      label: (
        <div className="text-[3vw] text-[#1F4B7F]  font-semibold">
          All
        </div>
      ),
    },
    {
      value: 2,
      label: (
        <div className="text-[3vw] text-[#1F4B7F]  font-semibold">
          Website
        </div>
      ),
    },
    {
      value: 3,
      label: (
        <div className="text-[3vw] text-[#1F4B7F]  font-semibold">
          Mobile
        </div>
      ),
    }
  ];

  const defaultvalues = {
      value: 1,
      label: (
        <div className="text-[3vw] text-[#1F4B7F]  font-semibold">
          All
        </div>
      ),
  };

    const handleDeviceChange = (value) => {
      console.log(value,"vavavavavavav")
      if (value === 1) {
        setIsView("All");
                setDeviceId(0);
                setActivePage(1);
                setActivePicker("Weekly");
                setSwap("amount");
                if (table === "bookings" || table === "cancellation") {
                  setDateClear();
                }
                if (!dateClear) {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    0,
                    "null",
                    "null",
                    1,
                    1
                  );
                } else {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    0,
                    moment(dateClear[0].$d).format("YYYY-MM-DD"),
                    moment(dateClear[1].$d).format("YYYY-MM-DD"),
                    1,
                    1
                  );
                }
      } else if(value === 2){
        setIsView("Desktop");
                setDeviceId(1);
                setActivePage(1);
                console.log(table, isView, deviceid, "dtihhhh");
                setActivePicker("Weekly");
                setSwap("amount");
                if (table === "bookings" || table === "cancellation") {
                  setDateClear();
                }
                if (!dateClear) {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    1,
                    "null",
                    "null",
                    1,
                    1
                  );
                } else {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    1,
                    moment(dateClear[0].$d).format("YYYY-MM-DD"),
                    moment(dateClear[1].$d).format("YYYY-MM-DD"),
                    1,
                    1
                  );
                }
      } else if(value === 3){
        setIsView("Mobile");
                setDeviceId(2);
                setActivePage(1);
                console.log(table, isView, deviceid, "dtihhhh");
                setActivePicker("Weekly");
                if (table === "bookings" || table === "cancellation") {
                  setDateClear();
                }

                if (!dateClear) {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    2,
                    "null",
                    "null",
                    1,
                    1
                  );
                } else {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    2,
                    moment(dateClear[0].$d).format("YYYY-MM-DD"),
                    moment(dateClear[1].$d).format("YYYY-MM-DD"),
                    1,
                    1
                  );
                }

                console.log(dates, "ddddddddddddd");
                setSwap("amount");
      }
    };

    const menuOptions = [
    {
      value: 1,
      label: (
        <div className="text-[3vw] text-[#1F4B7F]  font-semibold">
          Dashboard
        </div>
      ),
    },
    {
      value: 2,
      label: (
        <div className="text-[3vw] text-[#1F4B7F]  font-semibold">
          Bookings
        </div>
      ),
    },
    {
      value: 3,
      label: (
        <div className="text-[3vw] text-[#1F4B7F]  font-semibold">
          Cancellation
        </div>
      ),
    }
  ];

    const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuChange = (value) => {
    console.log("Selected:", value);
    setMenuOpen(false); // Close menu after selection
    if(value === 1){
      setTable("dashboard");
                setIsDisabled(true);
                setDeviceId(0);
                setIsView("All");
                setInputValue("");
                setDateClear();
                setDates();
                setActivePicker("Weekly");
    } else if(value === 2){
      setTable("bookings");
                setIsDisabled(false);
                setActivePage(1);
                setDeviceId(0);
                setIsView("All");
                setInputValue("");
                setDateClear();
                setActivePicker("Weekly");
                setDates();
    } else if(value === 3){
      setTable("cancellation");
                setIsDisabled(false);
                setActivePage(1);
                setIsView("All");
                setInputValue("");
                setDateClear();
                setActivePicker("Weekly");
                setDates();
    }
  };


  return (
    <div
      className={`h-screen w-screen px-[2.5vw]`}
      style={{
        backgroundImage: `url(${Backdrop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h1 className="text-[#1F4B7F] pt-[0.5vw] text-[4vw] md:text-[1.5vw] font-bold">
        {table == "dashboard"
          ? "DASHBOARD"
          : table == "bookings"
          ? "BOOKED TICKETS"
          : table == "cancellation"
          ? "CANCELLED TICKETS"
          : table == "passengers"
          ? "PASSENGERS"
          : table == "blocked"
          ? "BLOCKED HISTORY"
          : "DASHBOARD"}
      </h1>

      <div className="flex justify-between items-start">
        {/* mobile menu bar */}
        <div className="block md:hidden">
          <div className=" border-[#1F487C] border-r-[0.75vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.75vw] rounded-[1vw] h-[7vw] overflow-hidden mt-[0vw] flex items-center justify-center">
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        optionActiveBg: "#e5e5e5", //aebed1
                        optionSelectedColor: "#FFF",
                        optionSelectedBg: '#e5e5e5',
                        optionHeight: "2",
                      },
                    },
                  }}
                >
                  <Select
                    // listHeight={190}
                    // labelInValue
                    value=""
                    showSearch={false}
                    onChange={handleMenuChange}
                    onDropdownVisibleChange={(open) => setMenuOpen(open)}
                    className={`custom-select bg-white border-r-[0.75vw] text-[2vw]  border-l-[0.1vw] border-t-[0.1vw] border-b-[0.75vw] placeholder-blue text-[#1F487C] h-[5.5vw] rounded-[1vw] outline-none `}
                    // className="custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-xl border-r-[0.2vw] border-b-[0.2vw] placeholder-[#1F487C]"
                    style={{height: "7vw", width: "5vw", padding: 0 }} // Compact trigger width
                    dropdownStyle={{ width: "25vw"}} // Wider dropdown
                    placeholder=""
                    optionFilterProp="value"
                    suffixIcon={
                      <span style={{ color: "#1f487c", marginTop: "2.5vw"}}>
                        {menuOpen ? <RxCross2 size="4.5vw" /> : <RiMenuFill size="4.5vw" />}
                      </span>
                    }
                    options={menuOptions}
                  />
                </ConfigProvider>
          </div>
        </div>
        
        <div className="relative flex items-center pb-[0.5vw] mt-[0vw] md:mt-0">
          <LiaSearchSolid
            className="absolute left-[0.5vw] inline-block text-[2.5vw] md:text-[1vw]"
            color="#9CA3AF"
          />
          <input
            type="text"
            className={`${
              table === "dashboard"
                ? "cursor-not-allowed hover:bg-zinc-500"
                : ""
            } bg-white outline-none pt-[0.75vw] md:pt-[0.25vw] pl-[3.25vw] md:pl-[2vw] w-[23vw] md:w-[17vw] text-[#1f487c] h-[7vw] md:h-[5vh] text-[2.5vw] md:text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[1vw] md:rounded-[0.75vw] border-r-[0.75vw] md:border-r-[0.25vw] border-b-[0.75vw] md:border-b-[0.25vw] pr-[2.5vw]`}
            placeholder="Search..."
            value={inputValue}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              Search(e);
              setInputValue(e.target.value);
            }}
            onDragStart={handleDragStart}
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
            disabled={isDisabled}
          />
          <span
            className={`inline-block ${
              table === "dashboard" ? "cursor-not-allowed" : "cursor-pointer"
            } text-[#1F4B7F] text-[1vw] align-text-bottom absolute right-[1vw]`}
          >
            {" "}
            {/* {table === "bookings" ||
        table === "cancellation" ||
        table === "blocked" ||table==="passengers"?(<div
          className="absolute right-[-0.1vw] top-1/2 -translate-y-1/2 cursor-pointer text-gray-400"
          
          
        > */}
            {inputValue ? (
              <MdCancel
                className="text-[#1f487c] cursor-pointer mr-[-0.5vw] md:mr-0 text-[2vw] md:text-[1.3vw]"
                onClick={() => {
                  handleClear();
                  // setPopoverVisible(false);
                }}
              />
            ) : (
              <Popover
                color="white"
                title={
                  table == "dashboard" ? (
                    ""
                  ) : (
                    <div className=" text-[#1F4B7F] p-[1vw] max-h-[20vw] overflow-auto ">
                      <span className="font-bold">SEARCH BY...</span>
                      {table == "passengers"
                        ? infos2.map((info, index) => (
                            <div key={index} className="flex flex-col">
                              <ul
                                className="pl-[1vw]"
                                style={{ listStyleType: "disc" }}
                              >
                                <li className="text-[0.8vw] ">
                                  <p className="">{info.title}</p>
                                </li>
                              </ul>
                              <span className="text-[.7vw] pl-[1vw] text-[#9CA3AF]">
                                {info.description}
                              </span>
                            </div>
                          ))
                        : table == "bookings"
                        ? infos3.map((info, index) => (
                            <div key={index} className="flex flex-col">
                              <ul
                                className="pl-[1vw]"
                                style={{ listStyleType: "disc" }}
                              >
                                <li className="text-[0.8vw] ">
                                  <p className="">{info.title}</p>
                                </li>
                              </ul>
                              <span className="text-[.7vw] pl-[1vw] text-[#9CA3AF]">
                                {info.description}
                              </span>
                            </div>
                          ))
                        : infos1.map((info, index) => (
                            <div key={index} className="flex flex-col">
                              <ul
                                className="pl-[1vw]"
                                style={{ listStyleType: "disc" }}
                              >
                                <li className="text-[0.8vw] ">
                                  <p className="">{info.title}</p>
                                </li>
                              </ul>
                              <span className="text-[.7vw] pl-[1vw] text-[#9CA3AF]">
                                {info.description}
                              </span>
                            </div>
                          ))}
                    </div>
                  )
                }
                placement="bottom"
              >
                <div>
                  <BsExclamationCircle
                    color="#9CA3AF"
                    className="align-middle leading-none mr-[1px] md:mr-[4px] mb-[0px] md:mb-[2px] text-[2.5vw] md:text-[1.25vw] w-full"
                  />
                </div>
              </Popover>
            )}
            {/* </div>):(" ")} */}
          </span>
        </div>

        {/* <Link to="/dashboard/booking_table" className="text-[1.3vw] text-[#1f487c] text-center">Bookings</Link>
          <Link to="/dashboard/cancellation_table" className="text-[1.3vw] text-[#1f487c] text-center">Cancellation</Link>
          <Link to="" className="text-[1.3vw] text-[#1f487c] text-center">Passengers</Link> */}
        <div className="hidden md:block ">
          <div className="flex flex-col md:flex-row items-start pl-[1vw] gap-x-[3vw] -ml-[8.5vw]">
          {/* {(showDashboard || currenttypeid === "PRO101") && ( */}
          <div
            className={`${
              showDashboard || currenttypeid === "PRO101"
                ? ""
                : "cursor-not-allowed"
            }`}
          >
            <div
              className={` cursor-pointer ${
                table == "dashboard"
                  ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                  : ""
              } ${
                showDashboard || currenttypeid === "PRO101"
                  ? ""
                  : "pointer-events-none"
              }`}
              onClick={() => {
                setTable("dashboard");
                setIsDisabled(true);
                setDeviceId(0);
                setIsView("All");
                setInputValue("");
                setDateClear();
                setDates();
                setActivePicker("Weekly");
              }}
            >
              <p className="text-[1.3vw] text-[#1f487c] text-center">
                Dashboard
              </p>
            </div>
          </div>
          {/* )} */}
          {/* {(showBooking || currenttypeid === "PRO101") && ( */}
          <div
            className={`${
              showBooking || currenttypeid === "PRO101"
                ? ""
                : "cursor-not-allowed"
            }`}
          >
            <div
              className={` cursor-pointer ${
                table == "bookings"
                  ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                  : ""
              } ${
                showBooking || currenttypeid === "PRO101"
                  ? ""
                  : "pointer-events-none"
              }`}
              onClick={() => {
                setTable("bookings");
                setIsDisabled(false);
                setActivePage(1);
                setDeviceId(0);
                setIsView("All");
                setInputValue("");
                setDateClear();
                setActivePicker("Weekly");
                setDates();
              }}
            >
              <div className="text-[1.3vw] text-[#1f487c] text-center">
                Bookings
              </div>
            </div>
          </div>
          {/* )} */}

          {/* {(showCancel || currenttypeid === "PRO101") && ( */}
          <div
            className={`${
              showCancel || currenttypeid === "PRO101"
                ? ""
                : "cursor-not-allowed"
            }`}
          >
            <div
              className={` cursor-pointer ${
                table == "cancellation"
                  ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                  : ""
              } ${
                showCancel || currenttypeid === "PRO101"
                  ? ""
                  : "pointer-events-none"
              }`}
              onClick={() => {
                setTable("cancellation");
                setIsDisabled(false);
                setActivePage(1);
                setIsView("All");
                setInputValue("");
                setDateClear();
                setDeviceId(0);
                setActivePicker("Weekly");
                setDates();
              }}
            >
              <div className="text-[1.3vw] text-[#1f487c] text-center">
                Cancellation
              </div>
            </div>
          </div>
          {/* )} */}

          {/* <div
            className={` cursor-pointer ${
              table == "passengers"
                ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                : ""
            } `}
            onClick={() => {
              setTable("passengers");
              setIsDisabled(false);
              setActivePage(1);
              setDeviceId(0)
              setIsView("All")
              setInputValue('');
            }}
          >
            <div className="text-[1.3vw] text-[#1f487c] text-center">
              Passengers
            </div>
          </div> */}

          {/* <div
            className={` cursor-pointer ${
              table == "blocked"
                ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                : ""
            } `}
            onClick={() => {
              setTable("blocked");
              setIsDisabled(false);
              setActivePage(1);
              setDeviceId(0)
              setIsView("All")
              setInputValue('');
            }}
          >
            <div className="text-[1.3vw] text-[#1f487c] text-center">
              Blocked History
            </div>
          </div> */}
        </div>
        </div>

        

        <div className="flex items-end col-span-2">
          {table === "dashboard" ||
          table === "bookings" ||
          table === "cancellation" ||
          table === "blocked" ? (
            <>
            <div className="hidden md:block ">
              <div className="flex items-center justify-center -mr-[8vw]">
              <div className="reqman">
                <ConfigProvider
                  theme={{
                    token: {
                      fontSize: ".9vw",
                      lineHeight: 0,
                      colorPrimary: "#1F487C",
                    },
                    components: {
                      DatePicker: {
                        activeBorderColor: "#1F487C",
                        hoverBorderColor: "#1F487C",
                        activeShadow: "#1F487C",
                        cellWidth: 22,
                        cellHeight: 16,
                      },
                    },
                  }}
                >
                  <RangePicker
                    allowClear={true}
                    autoFocus={false}
                    onChange={datefilter}
                    value={dateClear}
                    inputReadOnly={true}
                    dropdownClassName="custom-datepicker-dropdown"
                    getPopupContainer={() => document.body}
                    transitionName="ant-slide-up" // or use your own like "fade"
                    popupStyle={{
                      transition: "none",
                    }}
                    // onKeyDown={handleKeyDateDown}

                    className="flex justify-center   ads-date1 border-r-[0.75vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]
                        text-[#1F487C] text-[0.8vw] rounded-[0.5vw] outline-none px-[1vw] placeholder-[#1F487C]"
                    // className="custom-range-picker bg-white outline-none pl-[1.5vw] w-[17vw] h-[2.5vw] text-[0.9vw] border-[#1F4B7F] border-l-[0.1vw] px-[1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.2vw] border-b-[0.2vw]"
                    // disabledDate={(current) => current < dayjs().startOf("day")}
                  />
                </ConfigProvider>
              </div>
            </div>
            </div>
            <div className="block md:hidden ">
              <div className="flex items-center justify-center mr-[7vw]">
              <div className="reqman">
                <ConfigProvider
                  theme={{
                    token: {
                      fontSize: "2.5vw",
                      lineHeight: 0,
                      colorPrimary: "#1F487C",
                    },
                    components: {
                      DatePicker: {
                        activeBorderColor: "#1F487C",
                        hoverBorderColor: "#1F487C",
                        activeShadow: "#1F487C",
                        cellWidth: 15,
                        cellHeight: 10,
                      },
                    },
                  }}
                >
                  <RangePicker
                    allowClear={true}
                    autoFocus={false}
                    onChange={datefilter}
                    value={dateClear}
                    inputReadOnly={true}
                    dropdownClassName="mobilecustom-datepicker-dropdown"
                    getPopupContainer={() => document.body}
                    transitionName="ant-slide-up" // or use your own like "fade"
                    popupStyle={{
                      transition: "none",
                    }}
                    // onKeyDown={handleKeyDateDown}

                    className="flex justify-center h-[7vw] w-[42.5vw] mt-[0vw] border-r-[0.75vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.75vw] placeholder-blue border-[#1F487C]
                        text-[#1F487C] text-[2.5vw] rounded-[1vw] outline-none px-[1vw] placeholder-[#1F487C] -mr-[7vw]"
                    // className="custom-range-picker bg-white outline-none pl-[1.5vw] w-[17vw] h-[2.5vw] text-[0.9vw] border-[#1F4B7F] border-l-[0.1vw] px-[1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.2vw] border-b-[0.2vw]"
                    // disabledDate={(current) => current < dayjs().startOf("day")}
                  />
                </ConfigProvider>
              </div>
            </div>
            </div>
            
            </>
          ) : (
            <div className="w-[20vw]"></div>
          )}
        </div>

        <div className="hidden md:block mr-[-8.3vw]">
          {table === "bookings" || table === "cancellation" ? (
          <div className="flex items-center gap-x-[1vw] h-[5vh] ">
            <Tooltip
              placement="bottom"
              title={
                <div className="flex items-center gap-x-[0.5vw] justify-center">
                  <CgExport color={"#1F487C"} size={"1vw"} />
                  <label className="text-[1vw] font-semibold">Export</label>
                </div>
              }
              className="cursor-pointer"
              color="white"
              overlayInnerStyle={{
                color: "#1F487C",
              }}
            >
              <div>
                <ExportButton
                  dataArray={table == "bookings" ? getBookingDetails || [] : ""}
                  dataArray2={
                    table == "cancellation" ? getCancellationDetails || [] : ""
                  }
                />
              </div>
            </Tooltip>
          </div>
        ) : (
          ""
        )}
        </div>

        {table === "dashboard" ||
        table === "bookings" ||
        table === "cancellation" ||
        table === "passengers" ||
        table === "blocked" ? (
          <>
          <div className="hidden md:block">
            <div className="flex border-[#1F487C] h-[2.5vh] md:h-[5vh] ">
            {/* <Tooltip
              placement="top"
              title={
                <div className="flex items-center gap-x-[0.5vw] justify-center">
                  <FaDesktop color={"#1F487C"} size={"1vw"} />
                  <label className="text-[1vw] font-semibold">All</label>
                </div>
              }
              className="cursor-pointer"
              color="white"
              overlayInnerStyle={{
                color: "#1F487C",
              }}
            > */}
            <button
              className={`${
                isView === "All" ? "bg-[#1F487C]" : "bg-[white]"
              } px-[0.75vw] rounded-l-[0.75vw] border-[0.1vw] border-b-[0.25vw] border-r-0  border-[#1F487C] flex items-center gap-[0.5vw]`}
              style={{
                transition: "all 1s",
              }}
              onClick={() => {
                setIsView("All");
                setDeviceId(0);
                setActivePage(1);
                 setSortedData([])
                setSortOrderDate(null)
                setSortOrderFare(null)
                setActivePicker("Weekly");
                setSwap("amount");
                if (table === "bookings" || table === "cancellation") {
                  setDateClear();
                }
                if (!dateClear) {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    0,
                    "null",
                    "null",
                    1,
                    1
                  );
                } else {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    0,
                    moment(dateClear[0].$d).format("YYYY-MM-DD"),
                    moment(dateClear[1].$d).format("YYYY-MM-DD"),
                    1,
                    1
                  );
                }
              }}
            >
              {/* <FaDesktop
                  color={`${isView === "Desktop" ? "white" : "#1F487C"}`}
                /> */}
              {isView === "All" ? (
                <img src={all1} className="w-[2.5vw] md:w-[1.25vw]" />
              ) : (
                <img src={all2} className="w-[2.5vw] md:w-[1.25vw]" />
              )}
              <p
                className={`text-[2.5vw] md:text-[1vw] font-semibold ${
                  isView === "All" ? "text-white" : "text-[#1F487C]"
                }`}
              >
                All
              </p>
            </button>
            {/* </Tooltip> */}
            {/* <Tooltip
              placement="top"
              title={
                <div className="flex items-center gap-x-[0.5vw] justify-center">
                  <FaDesktop color={"#1F487C"} size={"1vw"} />
                  <label className="text-[1vw] font-semibold">Website</label>
                </div>
              }
              className="cursor-pointer"
              color="white"
              overlayInnerStyle={{
                color: "#1F487C",
              }}
            > */}
            <button
              className={`${
                isView === "Desktop" ? "bg-[#1F487C]" : "bg-[white]"
              } px-[0.75vw] border-[0.1vw] border-b-[0.25vw] border-r-1  border-[#1F487C] flex items-center gap-[0.5vw]`}
              style={{
                transition: "all 1s",
              }}
              onClick={() => {
                setIsView("Desktop");
                setDeviceId(1);
                setActivePage(1);
                 setSortedData([])
                setSortOrderDate(null)
                setSortOrderFare(null)
                console.log(table, isView, deviceid, "dtihhhh");
                setActivePicker("Weekly");
                setSwap("amount");
                if (table === "bookings" || table === "cancellation") {
                  setDateClear();
                }
                if (!dateClear) {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    1,
                    "null",
                    "null",
                    1,
                    1
                  );
                } else {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    1,
                    moment(dateClear[0].$d).format("YYYY-MM-DD"),
                    moment(dateClear[1].$d).format("YYYY-MM-DD"),
                    1,
                    1
                  );
                }
              }}
            >
              <FaDesktop
                color={`${isView === "Desktop" ? "white" : "#1F487C"}`}
                className="text-[2.5vw] md:text-[1.25vw]"
              />
              <p
                className={`text-[2.5vw] md:text-[1vw] font-semibold ${
                  isView === "Desktop" ? "text-white" : "text-[#1F487C]"
                }`}
              >
                Website
              </p>
            </button>
            {/* </Tooltip> */}
            {/* <Tooltip
              placement="top"
              title={
                <div className="flex items-center gap-x-[0.5vw] justify-center">
                  <FaMobileAlt color={"#1F487C"} size={"1vw"} />
                  <label className="text-[1vw] font-semibold">Mobile</label>
                </div>
              }
              className="cursor-pointer"
              color="white"
              overlayInnerStyle={{
                color: "#1F487C",
              }}
            > */}
            <button
              className={`${
                isView === "Mobile" ? "bg-[#1F487C]" : "bg-[white]"
              } px-[0.75vw] rounded-r-[0.75vw] border-[0.1vw] border-b-[0.25vw] border-r-[0.25vw] border-l-0  border-[#1F487C] flex items-center gap-[0.5vw]`}
              style={{
                transition: "all 1s",
              }}
              onClick={() => {
                setIsView("Mobile");
                setDeviceId(2);
                setActivePage(1);
                setSortedData([])
                setSortOrderDate(null)
                setSortOrderFare(null)
                console.log(table, isView, deviceid, "dtihhhh");
                setActivePicker("Weekly");
                if (table === "bookings" || table === "cancellation") {
                  setDateClear();
                }

                if (!dateClear) {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    2,
                    "null",
                    "null",
                    1,
                    1
                  );
                } else {
                  GetDashboardDetails(
                    dispatch,
                    setSpinning,
                    2,
                    moment(dateClear[0].$d).format("YYYY-MM-DD"),
                    moment(dateClear[1].$d).format("YYYY-MM-DD"),
                    1,
                    1
                  );
                }

                console.log(dates, "ddddddddddddd");
                setSwap("amount");
              }}
            >
              <FaMobileAlt
                color={`${isView === "Mobile" ? "white" : "#1F487C"}`}
                className="text-[2.5vw] md:text-[1.25vw]"
              />
              <p
                className={`text-[2.5vw] md:text-[1vw] font-semibold ${
                  isView === "Mobile" ? "text-white" : "text-[#1F487C]"
                }`}
              >
                Mobile
              </p>
            </button>
            {/* </Tooltip> */}
          </div>

          </div>
          <div className="block md:hidden">
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        optionActiveBg: "#e5e5e5", //aebed1
                        optionSelectedColor: "#FFF",
                        optionSelectedBg: '#e5e5e5',
                        optionHeight: "2",
                      },
                    },
                  }}
                >
                  <Select
                    // listHeight={190}
                    onChange={handleDeviceChange}
                    className={` custom-select bg-white border-r-[0.75vw] w-[20vw] text-[3vw]  border-l-[0.1vw] border-t-[0.1vw] border-b-[0.75vw] placeholder-blue border-[#1F487C] text-[#1F487C] h-[7vw] rounded-[1vw] outline-none mt-[0vw]`}
                    // className="custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-xl border-r-[0.2vw] border-b-[0.2vw] placeholder-[#1F487C]"
                    placeholder=""
                    optionFilterProp="value"
                    suffixIcon={
                      <span style={{ color: "#1f487c", marginTop: "2vw"}}>
                        <IoMdArrowDropdown size="5vw" />
                      </span>
                    }
                    style={{ padding: 0 }}
                    dropdownStyle={{ width: "20vw"}}
                    defaultValue={defaultvalues}
                    options={options}
                  />
                </ConfigProvider>
          </div>
          </>
        ) : (
          <div className="w-[1vw]"></div>
        )}
      </div>

      {table == "dashboard" ? (
        <>
          <div className="hidden md:block">
            <DashTableNew
              setTable={setTable}
              deviceid={deviceid}
              activePicker={activePicker}
              setActivePicker={setActivePicker}
              swap={swap}
              setSwap={setSwap}
              dates={dates}
              isView={isView}
              dateClear={dateClear}
            />
          </div>
          <div className="block md:hidden">
            <DashTableNewMobile
              setTable={setTable}
              deviceid={deviceid}
              activePicker={activePicker}
              setActivePicker={setActivePicker}
              swap={swap}
              setSwap={setSwap}
              dates={dates}
              isView={isView}
              dateClear={dateClear}
            />
          </div>
        </>
      ) : // <DashTable/>
      table == "bookings" ? (
        <>
        <div className="hidden md:block">
          <BookingTable
          activePage={activePage}
          setActivePage={setActivePage}
          deviceid={deviceid}
          sortedData={sortedData}
          setSortedData={setSortedData}
          sortOrderDate={sortOrderDate}
          setSortOrderDate={setSortOrderDate}
          sortOrderFare={sortOrderFare}
          setSortOrderFare={setSortOrderFare}
        />
        </div>
        <div className="block md:hidden">
          <BookingTableMobile
          activePage={activePage}
          setActivePage={setActivePage}
          deviceid={deviceid}
        />
        </div>
        </>
      ) : table == "cancellation" ? (
        <>
        <div className="hidden md:block">
          <CancelTable
          activePage={activePage}
          setActivePage={setActivePage}
          deviceid={deviceid}
          sortedData={sortedData}
          setSortedData={setSortedData}
          sortOrderDate={sortOrderDate}
          setSortOrderDate={setSortOrderDate}
          sortOrderFare={sortOrderFare}
          setSortOrderFare={setSortOrderFare}
        />
        </div>
        <div className="block md:hidden">
          <CancelTableMobile
          activePage={activePage}
          setActivePage={setActivePage}
          deviceid={deviceid}
        />
        </div>
        </>
      ) : // <ChartFun isSidebarOpen={activePage} selectedModule={setActivePage}/>
      table == "passengers" ? (
        <PassengerTable
          activePage={activePage}
          setActivePage={setActivePage}
          deviceid={deviceid}
        />
      ) : table == "blocked" ? (
        <BlockTable
          activePage={activePage}
          setActivePage={setActivePage}
          deviceid={deviceid}
        />
      ) : (
        // <DashTable/>
        <>
          <div className="hidden md:block">
            <DashTableNew
              setTable={setTable}
              deviceid={deviceid}
              activePicker={activePicker}
              setActivePicker={setActivePicker}
              swap={swap}
              setSwap={setSwap}
              dates={dates}
              isView={isView}
              dateClear={dateClear}
            />
          </div>
          <div className="block md:hidden">
            <DashTableNewMobile
              setTable={setTable}
              deviceid={deviceid}
              activePicker={activePicker}
              setActivePicker={setActivePicker}
              swap={swap}
              setSwap={setSwap}
              dates={dates}
              isView={isView}
              dateClear={dateClear}
            />
          </div>
        </>
      )}
      {/* <Link to="/dashboard/booking_table">Component 1</Link> */}
      {/* <Outlet /> */}
    </div>
  );
};

export default Dashboard;
